import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;
const adminEndpoint = process.env.VUE_APP_RESOURCE_URL;

const changeNetworkStatus = (coin, network = "ALL") => {
  coin = coin.toUpperCase();
  network = network.toUpperCase();
  return http.post(adminEndpoint + "/admin/assets/" + `${coin}/${network}`);
};

const changeAssetStatus = (symbol, side) => {
  return http.post(
    endpoint + "/Assets/" + `${symbol}/${side}`,
  );
};

export {changeNetworkStatus, changeAssetStatus};
